import { SIGNING_TYPES } from "../constants";

export const SIGNING_BUTTON_TEXT = {
  [SIGNING_TYPES.SIGNING]: "SIGNING_TYPE_BUTTON_TITLES.SIGN",
  [SIGNING_TYPES.VISE]: "SIGNING_TYPE_BUTTON_TITLES.VISE",
};

export const SIGNING_WITH_CERTIFICATE_STATUSES = {
  BEGIN_SIGNING: "BEGIN_SIGNING",
  SIGNING: "SIGNING",
} as const;
